module.exports = __webpack_public_path__ + "static/media/prevIcon.5cedb272.svg";